<template>
    <app_modal :showHeader="true" :headerText="$t('Filters')">
        <template slot="modal_content">
            <div
                class="bg-white dark:bg-neutral-800 flex flex-col gap-2 rounded-md shadow-xl p-8 animate-in fade-in zoom-in w-full max-w-screen-md w-full">
                <div class="">
                    <div class="font-bold dark:text-white text-xl mb-4">{{ $t('price') }}:</div>
                    <div class="w-full flex flex-col md:flex-row border dark:border-neutral-700 rounded-lg dark:text-white justify-between">
                        <a :href="$attrs.mainevent ? '?price=' +'&event=' + JSON.parse($attrs.mainevent).slug : '?price='" class="p-4 cursor-pointer transition text-center hover:bg-gray-300 dark:text-white dark:hover:bg-neutral-700 grow text-base"
                            :class="[!filters.hasOwnProperty('price') ? 'bg-gradient shadow-xl text-white rounded-lg' : '']">
                            {{ $t('All events') }}
                        </a>
                        <a :href="$attrs.mainevent ? '?price=^' +'&event=' + JSON.parse($attrs.mainevent).slug : '?price=^'" class="p-4 cursor-pointer transition text-center hover:bg-gray-300 dark:text-white dark:hover:bg-neutral-700 grow text-base md:border-l dark:border-neutral-700 md:border-r"
                            :class="['price' in filters && filters.price == 'priced' ? 'bg-gradient shadow-xl text-white rounded-lg' : '']">
                            {{ $t('Paid events') }}
                        </a>
                        <a :href="$attrs.mainevent ? '?price=0' +'&event=' + JSON.parse($attrs.mainevent).slug : '?price=0'" class="p-4 cursor-pointer transition text-center hover:bg-gray-300 dark:text-white dark:hover:bg-neutral-700 grow text-base"
                            :class="['price' in filters && filters.price == 0 ? 'bg-gradient shadow-xl text-white rounded-lg' : '']">
                            {{ $t('Free events') }}!
                        </a>
                    </div>
                </div>
            </div>
        </template>


        <template slot="modal_button">
            <div class="fixed bottom-20 CTAbottombutton right-4 sm:right-auto sm:bottom-0 sm:static bg-white sm:bg-gray-200 border border-gray-200 dark:border-neutral-700 sm:border-0 shadow-xl sm:shadow-none cursor-pointer dark:bg-neutral-700 dark:sm:bg-neutral-800 text-sm text-gray-500 dark:text-gray-400 leading-none border-2 sm:border-gray-200 dark:sm:border-neutral-800 rounded-full inline-flex h-fit"
                :class="[Object.keys(filters).length > 0 ? 'bg-primary' : '']">
                <div class="inline-flex items-center transition-colors duration-300 ease-in focus:outline-none hover:text-primary rounded-full p-4 sm:p-2 text-sm h-fit dark:text-white"
                    :class="[Object.keys(filters).length > 0 ? '!text-white dark:!text-neutral-900 ' : '']" id="grid">
                    <svg class="h-6 w-6" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" />
                        <path d="M5.5 5h13a1 1 0 0 1 0.5 1.5L14 12L14 19L10 16L10 12L5 6.5a1 1 0 0 1 0.5 -1.5" />
                    </svg>
                </div>
            </div>
        </template>
    </app_modal>
</template>
  
<script>
export default {
    data() {
        return {
            filters: this.$attrs.filters ? JSON.parse(this.$attrs.filters) : [],
        }
    },
    methods: {
        toggleMenu(e) {
            console.log("HERE");
            if (this.open) {
                $("body").addClass("scroll_lock")
            } else {
                $("body").removeClass("scroll_lock")
            }
        }
    }
};
</script>
  